import axios from '@axios'

const PREFIX = '/grupos-usuarios'

export default {

  getAll(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getRecursos(externo) {
    return axios.get(`${PREFIX}/recursos?externo=${externo}`)
  },

  getGrupo(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updateGrupo(id, grupo) {
    return axios.put(`${PREFIX}/${id}`, grupo)
  },

  createGrupo(grupo) {
    return axios.post(`${PREFIX}/add`, grupo)
  },

  delete(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  deleteAll(idList) {
    return axios.delete(`${PREFIX}/lote`, { data: idList })
  },

  getPorTipo(externo) {
    return axios.get(`${PREFIX}/tipo/${externo}`)
  },
}
